import { Inline } from '@heathmont/moon-components';
import { Caption } from '@heathmont/moon-core';
import { Popover } from '@heathmont/moon-core-tw';
import styled from 'styled-components';
import Translate from '~/client/shared/i18n/Translate';
import Categories from './Categories';
import ControlsChevronRight from '@/external/icons/ControlsChevronRight';

const InlineContainer = styled(Inline)`
  cursor: pointer;
`;

const BlogCategories = () => (
  <Popover position="bottom-end">
    <Popover.Trigger>
      <InlineContainer>
        <Caption>
          <Translate id="blog.categories" />
        </Caption>
        <ControlsChevronRight color="trunks.100" fontSize={24} />
      </InlineContainer>
    </Popover.Trigger>
    <Popover.Panel className=" p-6">
      <Categories />
    </Popover.Panel>
  </Popover>
);

export default BlogCategories;
